import axios from 'axios';

import { getContentType } from 'components/common/UploadModal/utils/getContentType';
import { restClient } from 'config/store/configureStore';
import { RETRY_NUMBER_TIMES } from 'constants/Global';

import { encodeFileToBase64 } from 'services/FileUtils';

import { fetchRetry } from '../services/Utils';

export const uploadMedia = async (url, file) => {
  const base64 = await encodeFileToBase64(file);
  const contentType = getContentType({ file });

  return restClient.post(url, base64, {
    headers: { 'Content-Type': contentType },
  });
};

export const uploadMediaSecureUrl = (url, fields, file) => {
  const formData = new FormData();
  Object.entries(fields).forEach(([key, value]) => {
    formData.append(key, value);
  });
  formData.append('file', file);
  return axios.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const fetchRetryMedia = (url, mediaId) =>
  new Promise((resolve, reject) => {
    fetchRetry(
      reject,
      () => {
        const callUrl = `${url}${mediaId ? `/${mediaId}` : ''}`;
        return restClient.get(callUrl).then(({ data, status }) => {
          if (status === 200) {
            resolve(data);
          } else {
            throw new Error();
          }
        });
      },
      RETRY_NUMBER_TIMES
    ).then(() => { });
  });

export const deleteMedia = (url, mediaId) => {
  const callUrl = `${url}${mediaId ? `/${mediaId}` : ''}`;
  return restClient.delete(callUrl);
};
